import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import configureStore from './store/configureStore';
import { Provider } from 'react-redux';
import { AuthProvider } from 'oidc-react';
import { oidcConfig } from './backend/openIdConnectInit';

const store = configureStore();


ReactDOM.render(
  <AuthProvider {...oidcConfig}>
    <Provider store={store}>
      <App  />
    </Provider>
  </AuthProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
